var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user_information"},[_c('crumbs',{staticClass:"breadcrumb-container"}),_c('keep-alive',[(_vm.$route.meta.keepAlive == true)?_c('router-view'):_vm._e()],1),(_vm.$route.meta.keepAlive == false)?_c('router-view'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }